import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { sprintf } from 'sprintf-js';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

// Non-bureau event Chats. Mirrors EventChatMessageService (bureau), pointed at
// the core_events URL namespace. list() returns { chats: string[] }.
@Injectable()
export class CoreEventChatMessageService extends BaseService {
  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/core_events/%(event_id)s/chats`);
  }

  // Opens a live chat room and invites the event's assigned staff.
  // Returns { chat_room_id }.
  requestChatRoom(urlParams: any = {}): Observable<any> {
    const url = sprintf(this.baseUrl, urlParams);
    return this.http.post<any>(url, {});
  }

  sendMessage(urlParams: any = {}, data: any = {}): Observable<any> {
    const url = sprintf(`${this.baseUrl}/%(room_id)s/messages`, urlParams);
    return this.http.post<any>(url, data);
  }
}
